import { useEffect, useState } from "react";
import { useMoralis } from "react-moralis";
import { ThemeProvider } from "@material-ui/core";
import MyRoutes from "./components/Routes";
import theme from "./Theme";
import { MusicProvider } from "./provider/MusicProvider";
import Player from "./components/Player";
import { ethers } from "ethers";
import contractAbi from "./moralis/abi.json";
import { useMoralisWeb3Api, useMoralisWeb3ApiCall } from "react-moralis";
import { MoralisProvider } from 'react-moralis';

const APP_ID = process.env.REACT_APP_MORALIS_APPLICATION_ID;
const SERVER_URL = process.env.REACT_APP_MORALIS_SERVER_URL;
const contractAddress = process.env.REACT_APP_CONTRACT_ADDRESS;
const maxSupply = process.env.REACT_APP_MAX_SUPPLY;
const maxStock = ["45", "5","5","5"];

let web3Provider, contract, sale_filter;
if(window.ethereum){
  web3Provider = new ethers.providers.Web3Provider(window.ethereum);
  contract = new ethers.Contract(contractAddress, contractAbi, web3Provider);
  // console.log(contract);
  sale_filter = contract.filters.NowOnSale(null);
}

const handleOption = (id) => {
  const options = {
    chain: "0x1",
    address: contractAddress,
    function_name: "totalSupply",
    abi: [{"inputs":[{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"}],
    params: {_tokenId:id}
  };
  return options;
}

const option = {
  chain: "0x1",
  address: contractAddress,
  function_name: "sales",
  abi: [{"inputs":[{"internalType":"uint256","name":"para","type":"uint256"}],"name":"sales","outputs":[{"internalType":"enum WAGMIMusicToken1155.saletate","name":"","type":"uint8"}],"stateMutability":"view","type":"function"}],
  params: {para:1}
};

const nfts = [
  {image:'/image/wagmi1-320px.jpg',
  title:'WAGMI - Normal',
  artist:'Hibikilla',
  etherscan: 'https://polygonscan.com/address/0x2953399124f0cbb46d2cbacd8a89cf0599974963',
  opensea: 'https://opensea.io/ja/assets/matic/0x2953399124f0cbb46d2cbacd8a89cf0599974963/78555306292208822264975053909961537674478548303611333324072215595578311049286'},
  {image:'/image/wagmi2-320px.jpg',
  title:'WAGMI - MV Rare',
  artist:'Hibikilla',
  etherscan: 'https://polygonscan.com/address/0x2953399124f0cbb46d2cbacd8a89cf0599974963',
  opensea: 'https://opensea.io/ja/assets/matic/0x2953399124f0cbb46d2cbacd8a89cf0599974963/78555306292208822264975053909961537674478548303611333324072215596677822676997'},
  {image:'/image/wagmi3-320px.jpg',
  title:'WAGMI - Record Rare',
  artist:'Hibikilla',
  etherscan: 'https://polygonscan.com/address/0x2953399124f0cbb46d2cbacd8a89cf0599974963',
  opensea: 'https://opensea.io/ja/assets/matic/0x2953399124f0cbb46d2cbacd8a89cf0599974963/78555306292208822264975053909961537674478548303611333324072215597777334304773'},
  {image:'/image/wagmi4-320px.jpg',
  title:'WAGMI - acappella',
  artist:'Hibikilla',
  etherscan: 'https://polygonscan.com/address/0x2953399124f0cbb46d2cbacd8a89cf0599974963',
  opensea: 'https://opensea.io/ja/assets/matic/0x2953399124f0cbb46d2cbacd8a89cf0599974963/78555306292208822264975053909961537674478548303611333324072215601075869188106'},
  {image:'/image/omni1-320px.jpg',
  title:"Risin To The Top feat. Laya",
  artist:'Hibikilla',
  etherscan: 'https://polygonscan.com/address/0xb4fa9fee7b4f359a4c805b27932bca017d78bfeb',
  opensea: 'https://opensea.io/ja/assets/matic/0xb4fa9fee7b4f359a4c805b27932bca017d78bfeb/1'},
  {image:'/image/omni2-320px.jpg',
  title:'Risin To The Top feat. Laya',
  artist:'Hibikilla',
  etherscan: 'https://polygonscan.com/address/0xb4fa9fee7b4f359a4c805b27932bca017d78bfeb',
  opensea: 'https://opensea.io/ja/assets/matic/0xb4fa9fee7b4f359a4c805b27932bca017d78bfeb/2'},
  {image:'/image/omni3-320px.jpg',
  title:'Risin To The Top feat. Laya',
  artist:'Hibikilla',
  etherscan: 'https://polygonscan.com/address/0xb4fa9fee7b4f359a4c805b27932bca017d78bfeb',
  opensea: 'https://opensea.io/ja/assets/matic/0xb4fa9fee7b4f359a4c805b27932bca017d78bfeb/3'},
  {image:'/image/omni4-320px.jpg',
  title:'Risin To The Top feat. Laya',
  artist:'Hibikilla',
  etherscan: 'https://polygonscan.com/address/0xb4fa9fee7b4f359a4c805b27932bca017d78bfeb',
  opensea: 'https://opensea.io/ja/assets/matic/0xb4fa9fee7b4f359a4c805b27932bca017d78bfeb/4'},
  {image:'/image/omni5-320px.jpg',
  title:'Risin To The Top feat. Laya',
  artist:'Hibikilla',
  etherscan: 'https://polygonscan.com/address/0xb4fa9fee7b4f359a4c805b27932bca017d78bfeb',
  opensea: 'https://opensea.io/ja/assets/matic/0xb4fa9fee7b4f359a4c805b27932bca017d78bfeb/5'},
  {image:'/image/omni6-320px.jpg',
  title:'Risin To The Top feat. Laya',
  artist:'Hibikilla',
  etherscan: 'https://polygonscan.com/address/0xb4fa9fee7b4f359a4c805b27932bca017d78bfeb',
  opensea: 'https://opensea.io/ja/assets/matic/0xb4fa9fee7b4f359a4c805b27932bca017d78bfeb/6'},
  {image:'/image/omni7-320px.jpg',
  title:'Risin To The Top feat. Laya',
  artist:'Hibikilla',
  etherscan: 'https://polygonscan.com/address/0xb4fa9fee7b4f359a4c805b27932bca017d78bfeb',
  opensea: 'https://opensea.io/ja/assets/matic/0xb4fa9fee7b4f359a4c805b27932bca017d78bfeb/7'},
  {image:'/image/badmind1.webp',
  title:'Bad Mind feat. Itaq',
  artist:'Hibikilla',
  etherscan: 'https://polygonscan.com/address/0xb4fa9fee7b4f359a4c805b27932bca017d78bfeb',
  opensea: 'https://opensea.io/ja/assets/ethereum/0xa86a7046800c57236b61d1587f4abe9b38ab6f5d/0'},
  {image:'/image/luna1-320px.png',
  // alias:'luna',
  title:'LUNA - Original',
  artist:'Hibikilla',
  etherscan: 'https://etherscan.io/address/0xd91a3ad7c4e093e1a934481cdc6755221e0c6ac4',
  opensea: 'https://opensea.io/ja/assets/ethereum/0xd91a3ad7c4e093e1a934481cdc6755221e0c6ac4/1'},
  {image:'/image/luna2-320px.png',
  // alias:'luna',
  title:'LUNA - Special',
  artist:'Hibikilla',
  etherscan: 'https://etherscan.io/address/0xd91a3ad7c4e093e1a934481cdc6755221e0c6ac4',
  opensea: 'https://opensea.io/ja/assets/ethereum/0xd91a3ad7c4e093e1a934481cdc6755221e0c6ac4/2'},
  {image:'/image/luna3-320px.png',
  // alias:'luna',
  title:'LUNA - Instrumental',
  artist:'Hibikilla',
  etherscan: 'https://etherscan.io/address/0xd91a3ad7c4e093e1a934481cdc6755221e0c6ac4',
  opensea: 'https://opensea.io/ja/assets/ethereum/0xd91a3ad7c4e093e1a934481cdc6755221e0c6ac4/3'},
  {image:'/image/luna4-320px.png',
  // alias:'luna',
  title:'LUNA - Acappella',
  artist:'Hibikilla',
  etherscan: 'https://etherscan.io/address/0xd91a3ad7c4e093e1a934481cdc6755221e0c6ac4',
  opensea: 'https://opensea.io/ja/assets/ethereum/0xd91a3ad7c4e093e1a934481cdc6755221e0c6ac4/4'}
];

let minted = [0,0,0,0];
let checker = [true, true, true, true, true];

const App = () => {
  const { native } = useMoralisWeb3Api();
  const { isWeb3Enabled, enableWeb3, isAuthenticated, account, isWeb3EnableLoading } =
    useMoralis();

  /*
  *  sales == 0 => prepared
  *  sales == 1 => presale
  *  sales == 2 => pulicsale
  *  sales == 3 => suspended
  */
  const [sales, setSales] = useState("0");
  const [supply, setSupply] = useState([true, true, true, true]);
  const [update, setUpdate] = useState(0);

  useEffect(() => {
    const connectorId = window.localStorage.getItem("connectorId");
    if (isAuthenticated && !isWeb3Enabled && !isWeb3EnableLoading)
      enableWeb3({ provider: connectorId });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, isWeb3Enabled]);

  const getTotalSupplyA = useMoralisWeb3ApiCall(native.runContractFunction,{...handleOption(1)});
  const getTotalSupplyB = useMoralisWeb3ApiCall(native.runContractFunction,{...handleOption(2)});
  const getTotalSupplyC = useMoralisWeb3ApiCall(native.runContractFunction,{...handleOption(3)});
  const getTotalSupplyD = useMoralisWeb3ApiCall(native.runContractFunction,{...handleOption(4)});
  const getSalesState = useMoralisWeb3ApiCall(native.runContractFunction,{...option});

  useEffect(() => {
      if(checker[0]){
        getTotalSupplyA.fetch();
        // console.log("fetch");
        checker[0] =false;
      }    
      if(checker[1]){
        getTotalSupplyB.fetch();
        checker[1] =false;
      }
      if(checker[2]){
        getTotalSupplyC.fetch();
        checker[2] =false;
      }
      if(checker[3]){
        getTotalSupplyD.fetch();
        checker[3] =false;
      }
      if(checker[4]){
        getSalesState.fetch();
        checker[4]=false;
      }
  },[]);

  useEffect(() => {
    if(getTotalSupplyA.data){
      minted[0] = getTotalSupplyA.data;
      supply[0] = (maxStock[0]!==minted[0]);
      // console.log("dataA filled", minted, getTotalSupplyA.error);
    }
  }, [getTotalSupplyA.data, minted[0]])

  useEffect(() =>{
    if(getTotalSupplyB.data){
      minted[1] = getTotalSupplyB.data;
      supply[1] = (maxStock[1]!==minted[1]);
      // console.log("dataB filled", minted, getTotalSupplyB.error);
    }
  },[getTotalSupplyB.data, minted[1]])

  useEffect(() =>{
    if(getTotalSupplyC.data){
      minted[2] = getTotalSupplyC.data;
      supply[2] = (maxStock[2]!==minted[2]);
      // console.log("dataC filled", minted, getTotalSupplyC.error);
    }
  },[getTotalSupplyC.data, minted[2]])

  useEffect(() =>{
    if(getTotalSupplyD.data){
      minted[3] = getTotalSupplyD.data;
      supply[3] = (maxStock[3]!==minted[3]);
      // console.log("dataD filled", minted, getTotalSupplyD.error);
    }
  },[getTotalSupplyD.data, minted[3]])

  useEffect(() => {
    setSales(getSalesState.data)
    // console.log("sales filled", getSalesState.data)
  },[getSalesState.data])

    return (
      <>
      <MoralisProvider appId={APP_ID} serverUrl={SERVER_URL}>
        <ThemeProvider theme={theme}>
          <MusicProvider>
            <div style={{position:'fixed', left: 30, bottom: 25, zIndex: 2}}> 
              <Player sales={"1"}/>
            </div>
            <MyRoutes sales={sales} inStock={supply} maxSupply={maxSupply} minted={minted} data={nfts}/>
          </MusicProvider>
        </ThemeProvider>
      </MoralisProvider>
      </>
    );
}

export default App;